import { type ReactNode } from 'react';
import { Button } from '../button';

interface AlertProps {
  title: string;
  children: ReactNode;
  isOpen: boolean;
  onClose: () => void;
  onDelete: () => Promise<void>;
}

export const Alert = (props: AlertProps) => {
  if (!props.isOpen) return null;
  return (
    <div className='fixed top-0 right-0 bottom-0 left-0 z-[1600] flex items-center justify-center bg-[#191919cc]'>
      <div className='bg-gradient-to-b from-[#262626] to-[#1d1d1d] px-[40px] py-[10px] pb-[42px] shadow-[12px_12px_24px_0_rgba(0,0,0,0.23)]'>
        <div className='mt-5 mb-4 text-center text-base font-semibold text-[#fcfcfc] uppercase'>{props.title}</div>
        <div className='mb-10 text-center text-xs font-semibold text-[#929292] uppercase'>{props.children}</div>
        <div className='flex items-center justify-between gap-4'>
          <Button fullWidth color='outlined' onClick={props.onClose}>
            Cancel
          </Button>
          <Button fullWidth color='primary' onClick={props.onDelete}>
            Delete
          </Button>
        </div>
      </div>
    </div>
  );
};
